import { render } from "./ProcessingPaymentsReportPage.vue?vue&type=template&id=f8573090&scoped=true"
import script from "./ProcessingPaymentsReportPage.vue?vue&type=script&lang=js"
export * from "./ProcessingPaymentsReportPage.vue?vue&type=script&lang=js"

import "./ProcessingPaymentsReportPage.vue?vue&type=style&index=0&id=f8573090&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/ibsreg-test.theismailiusa.org/github-httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8573090"]])

export default __exports__